<template>
  <div class="pdf-doc">
    <div v-show="done === true">
      <pdf
        v-for="(i, k) in numPages"
        :src="documentPdf"
        @loaded="loaded"
        :page="i"
        :key="k"
      />
    </div>
    <div v-show="done === false"><h6>Загрузука PDF...</h6></div>
  </div>
</template>
<script>
import pdf from "vue-pdf";

export default {
  mounted() {
    this.documentPdf = pdf.createLoadingTask(this.src);
    this.documentPdf.promise.then((pdf) => {
      this.numPages = pdf.numPages;
    });
  },
  components: {
    pdf,
  },
  props: {
    src: {
      default: function () {
        return "";
      },
    },
  },
  methods: {
    loaded() {
      this.done = true;
    },
  },
  data() {
    return {
      documentPdf: null,
      numPages: 0,
      done: false,
    };
  },
};
</script>
<style>
.pdf-doc {
  overflow: hidden;
}
</style>

